module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_man-a8618d54c8b524fdd899850ca6228e34.png";